import { render } from "./image-text-grid-sec.vue?vue&type=template&id=f22a6694&scoped=true"
import script from "./image-text-grid-sec.vue?vue&type=script&lang=js"
export * from "./image-text-grid-sec.vue?vue&type=script&lang=js"

import "./image-text-grid-sec.vue?vue&type=style&index=0&id=f22a6694&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22a6694"]])

export default __exports__